import { render, staticRenderFns } from "./RetailOrdP.vue?vue&type=template&id=a1ee3b20&scoped=true"
import script from "./RetailOrdP.vue?vue&type=script&lang=js"
export * from "./RetailOrdP.vue?vue&type=script&lang=js"
import style0 from "./RetailOrdP.vue?vue&type=style&index=0&id=a1ee3b20&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ee3b20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1ee3b20')) {
      api.createRecord('a1ee3b20', component.options)
    } else {
      api.reload('a1ee3b20', component.options)
    }
    module.hot.accept("./RetailOrdP.vue?vue&type=template&id=a1ee3b20&scoped=true", function () {
      api.rerender('a1ee3b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inventory/RetailOrdP.vue"
export default component.exports